<template>
  <div class="indexPage footerPosition">
        <topInfo></topInfo>
        <div class="pageCom">
          <h2>Order Cancellation and Refund</h2>
          <div class="padTb">
            <h3>1.Order Cancellation</h3>
            <p>Shipments may be cancelled with no additional charge before the Seller has processed your shipment. Otherwise, you will be charged for any direct costs.</p>
          </div>
          <div class="padTb">
            <b>1.1 Freightshop may cancel an Order</b>
            <p>Since a Quote becomes a binding Order when booked, Freightshop may only cancel that Order under three circumstances:</p>
            <p>The service provider cannot physically execute the Order because of Force Majeure. Please note that any change in market conditions or carrier availability is not a valid reason for Order cancellation.</p>
            <p>Should there be a material discrepancy between the details entered by Buyer into the Order and the actual description of the goods or pickup times or other substantial discrepancies, Freightshop shall be entitled to cancel the Order and may charge Buyer for any documented and commercially reasonable costs incurred.</p>
            <p>Buyer fails to meet the service provider’s internal legal compliance requirements, as documented for their internal reference by the service provider.</p>
          </div>
          <div class="padTb">
            <b>1.2 How to Cancel an Order</b>
            <p>Send an email to support@by56.com</p>
            <p>Include the shipment number and the word “Cancellation” in the subject line.</p>
            <p>Please include a written explanation with the reason for cancellation and if there are any charges that have to be paid. If there are please detail and explain them.</p>
          </div>
          <div class="padTb">
            <b>1.3 Buyer Cancellation Policy</b>
            <p>Should the Buyer cancel an Order after the shipment has already incurred costs, Freightshop shall be entitled to payment for commercially reasonable and documented costs. These costs shall be subject to the service provider.</p>            
          </div>
          
           <div class="padTb">
            <b>1.4 When Freightshop may cancel an order</b>
            <p>Freightshop may cancel any Order during the Verification Process if it believes it not to be a viable Order.</p>
            <p>Freightshop may notify the parties that the Order has been cancelled at any time on behalf of either party due to non-compliance with Marketplace rules if:</p>
            <p>On behalf of Buyer:</p>
            <p>The service provider has not fulfilled all of the service provider’s obligations under the SOP and MSA and other Freightshop Policies.</p>
            <p>In this case, Freightshop shall have the right to transfer the Shipment to another service provider (as approved by Buyer), and the service provider shall have no claims arising from this cancelled Shipment.</p>
            <p>On behalf of service provider:</p>
            <p>A breach of contract has occurred on the part of the Buyer, including but not limited to:</p>
            <p>If Freightshop has reasonable cause to believe that Buyer will not perform their obligations per the contract.</p>
            <p>If Freightshop believes that the Buyer may not be legally eligible to purchase the Freight Services.</p>
          </div>
          <div class="padTb">
            <h3>2.Order Refund</h3>
            <p>In the process of providing freight services for you, if you cancel the order, change the service channel, cancel the selected service, etc., in addition to the additional expenses that need to be charged (such as changing the warehouse delivery fee, packaging fee, etc.) ), according to the actual situation, Freightshop.com will return the overcharged fee to you.</p>
            <p>Cancel order</p>
            <p>If your shipment has not been shipped, in addition to the additional charges for cancellation of the order and the services already provided to you, the other corresponding paid shipping charges and surcharges will be refunded back to your account.</p>
            <p>Change the service channel</p>
            <p>After the channel is changed, the fee will be charged according to the replaced channel.</p>
            <p>Cancel the selected service</p>
            <p>If you cancel the selected service, Freightshop will refund the corresponding paid fee to your account.</p>
          </div>          
        </div>
        <footerInfo></footerInfo>
  </div>
</template>

<script type="text/ecmascript-6">
  import topInfo from '../public/topInfo'
  import footerInfo from '../public/footerInfo'

  export default {
    components:{topInfo,footerInfo},
    data (){
      return {

      }
      
    },
    created(){   
    },
    methods:{

    }
  }
</script>
<style scoped>
  @import "../../../assets/css/about.css";
  .pageCom{width:1200px;margin:20px auto;}
  .padTb{padding-top:10px}
  .padTb p{line-height:20px;color:#666;font-size:12px;}

</style>



// WEBPACK FOOTER //
// src/components/reception/otherPage/refund.vue